import { IToken } from '../../shared/contexts/styleContext';
import { css } from '@emotion/core';

export const dividerStyle = (token: IToken) => css`
    background-color: ${token.colors.border.primary};
    height: 1px;
    border: none;
`;
